import AddAssemblyMaterials from './AddAssemblyMaterials';

export default AddAssemblyMaterials;